import { DatalabPaywallPaymentType, DatalabPaywallTier, } from "../generated";
import { HasDatalabFeatureAccess, datalabTierFeatureAccess, } from "./features";
export const resource_memory_cost_per_gb_per_hour = 0.14;
export const resource_storage_cost_per_gb_per_hour = 0.008;
export const datalabTierHierarchy = {
    [DatalabPaywallTier.datalab_tier_0]: 1,
    [DatalabPaywallTier.datalab_tier_a]: 2,
    [DatalabPaywallTier.datalab_tier_b]: 3,
    [DatalabPaywallTier.datalab_tier_c]: 4,
    [DatalabPaywallTier.datalab_tier_d]: 5,
};
export const usableDatalabTiers = {
    [DatalabPaywallTier.datalab_tier_0]: true,
    [DatalabPaywallTier.datalab_tier_a]: true,
    [DatalabPaywallTier.datalab_tier_b]: true,
    [DatalabPaywallTier.datalab_tier_c]: false,
    [DatalabPaywallTier.datalab_tier_d]: false,
};
export const datalabTiersOrderedLowToHigh = Object.values(DatalabPaywallTier).sort((a, b) => datalabTierHierarchy[a] - datalabTierHierarchy[b]);
export const compareDatalabTier = ({ currentTier, newTier, }) => {
    const tierDifference = datalabTierHierarchy[newTier] - datalabTierHierarchy[currentTier];
    return tierDifference > 0
        ? "upgrade"
        : tierDifference < 0
            ? "downgrade"
            : "same";
};
export const getHighestDatalabTier = (tiers) => {
    const defaultTier = null;
    return tiers.reduce((currentHighest, tier) => {
        if (currentHighest === null) {
            return tier;
        }
        return datalabTierHierarchy[tier] > datalabTierHierarchy[currentHighest]
            ? tier
            : currentHighest;
    }, defaultTier);
};
export const MatchPaymentMethod = (paymentMethod, matcher) => {
    return matcher[paymentMethod]();
};
export const MatchTierChange = (tierChange, matcher) => {
    return matcher[tierChange]();
};
export const getLowestDatalabTierWithAccess = (desiredFeature) => {
    for (const tier of datalabTiersOrderedLowToHigh) {
        const featureAccess = datalabTierFeatureAccess[tier][desiredFeature.feature];
        if (HasDatalabFeatureAccess({
            desiredFeature,
            currentFeatureAccess: featureAccess,
        })) {
            return { tier, featureAccess };
        }
    }
    return null;
};
export const getLowestUsableDatalabTierWithAccess = (desiredFeature) => {
    for (const tier of datalabTiersOrderedLowToHigh) {
        const featureAccess = datalabTierFeatureAccess[tier][desiredFeature.feature];
        if (HasDatalabFeatureAccess({
            desiredFeature,
            currentFeatureAccess: featureAccess,
        }) &&
            usableDatalabTiers[tier]) {
            return { tier, featureAccess };
        }
    }
    return null;
};
export const addAddonToFeatureAccess = ({ featureAccess, addon, }) => {
    const addonAccess = addon === null || addon === void 0 ? void 0 : addon.access;
    if (!addonAccess ||
        addonAccess === "none" ||
        addon.feature !== featureAccess.feature) {
        return featureAccess;
    }
    const isUnlimited = featureAccess.access === "unlimited" || addonAccess === "unlimited";
    if (isUnlimited) {
        return {
            ...featureAccess,
            access: "unlimited",
        };
    }
    if (featureAccess.access === "none") {
        return {
            ...featureAccess,
            access: addonAccess,
        };
    }
    return {
        ...featureAccess,
        access: addonAccess + featureAccess.access,
    };
};
//# sourceMappingURL=tiers.js.map